import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppService } from 'src/app/app.service';

export interface PortOutMessage {
  id: number;
  createdDate: string;
  message: any;
}

export interface PortOut {
  id: number;
  createdDate: string;
  msisdn: string;
  centralNodeId: string;
  bssPortaRef: string;
  windowTime: string;
  oldStatus: string;
  newStatus: string;
  msg: string;
  remoteIdo: string;
  remoteNrn: string;
  ponr: boolean;
  portoutFinalized: boolean;
  initPortOutSmsSent: boolean;
  billingAccount: string;
  portOutTaskId: string;
  arsTerminationSent: boolean;
  arsTerminationSentResult: string;
  arsTerminationJobId: string;
  arsTerminationStatus: string;
  arsTerminationError: any;
  messages?: PortOutMessage[];
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

export interface PortOutFilter {
  msisdn?: string;
  billingAccount?: string;
  initPortOutSmsSent?: boolean;
  remoteIdo?: string;
  newStatus?: string;
  windowTimeFrom?: string;
  windowTimeTo?: string;
  createdDateFrom?: string;
  createdDateTo?: string;
  ponr?: boolean;
  portoutFinalized?: boolean;
  portOutTaskId?: string;
  arsTerminationSentResult?: string;
  page?: number;
  size?: number;
  sortField?: string;
  sortDirection?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PortOutService {

  appData: any;

  constructor(
    private httpClient: HttpClient,
    private appService: AppService
  ) {
    this.appData = appService.settings;
  }

  search(filter: PortOutFilter): Observable<PageResponse<PortOut>> {
    let params = new HttpParams()
      .set('page', String(filter.page || 0))
      .set('size', String(filter.size || 20));

    if (filter.msisdn)                              params = params.set('msisdn', filter.msisdn);
    if (filter.billingAccount)                      params = params.set('billingAccount', filter.billingAccount);
    if (filter.initPortOutSmsSent != null)          params = params.set('initPortOutSmsSent', String(filter.initPortOutSmsSent));
    if (filter.remoteIdo)                           params = params.set('remoteIdo', filter.remoteIdo);
    if (filter.newStatus)                           params = params.set('newStatus', filter.newStatus);
    if (filter.windowTimeFrom)                      params = params.set('windowTimeFrom', filter.windowTimeFrom);
    if (filter.windowTimeTo)                        params = params.set('windowTimeTo', filter.windowTimeTo);
    if (filter.createdDateFrom)                     params = params.set('createdDateFrom', filter.createdDateFrom);
    if (filter.createdDateTo)                       params = params.set('createdDateTo', filter.createdDateTo);
    if (filter.ponr != null)                        params = params.set('ponr', String(filter.ponr));
    if (filter.portoutFinalized != null)            params = params.set('portoutFinalized', String(filter.portoutFinalized));
    if (filter.portOutTaskId)        params = params.set('portOutTaskId', filter.portOutTaskId);
    if (filter.arsTerminationSentResult) params = params.set('arsTerminationSentResult', filter.arsTerminationSentResult);
    if (filter.sortField)     params = params.set('sortField', filter.sortField);
    if (filter.sortDirection) params = params.set('sortDirection', filter.sortDirection);

    return this.httpClient.get<PageResponse<PortOut>>(`${this.appData.webApi}/port-out`, { params });
  }

  findById(id: number): Observable<PortOut> {
    return this.httpClient.get<PortOut>(`${this.appData.webApi}/port-out/${id}`);
  }
}
